module.exports = __webpack_public_path__ + "static/media/sirens.d93f4b19.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/media/sirens.mp4
// module id = 91
// module chunks = 0